import Vue from 'vue'

export default {
    login: (loginInput) => {
        return Vue.prototype.$http("/graphql", {
            data:{
              query: `{
                login(data: { email: "${loginInput.email}", senha: "${loginInput.senha}" }) {
                  token
                  usuario{
                    id
                    nome
                    email
                    senha
                    role
                  }
                }
              }`
            }
        })
    },
}
